/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { FamilyServiceDocumentStructureExtended } from '../models';
// @ts-ignore
import type { InputParseDocumentForFamilyRequirements } from '../models';
// @ts-ignore
import type { InputParseDocumentForRequirements } from '../models';
// @ts-ignore
import type { ServiceDocumentStructureExtended } from '../models';
/**
 * DocumentParserApi - axios parameter creator
 * @export
 */
export const DocumentParserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Parse document for family requirements
         * @param {InputParseDocumentForFamilyRequirements} [inputParseDocumentForFamilyRequirements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseDocumentForFamilyRequirements: async (inputParseDocumentForFamilyRequirements?: InputParseDocumentForFamilyRequirements, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/parser/family-document-parser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputParseDocumentForFamilyRequirements, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Parse document for requirements
         * @param {InputParseDocumentForRequirements} [inputParseDocumentForRequirements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseDocumentForRequirements: async (inputParseDocumentForRequirements?: InputParseDocumentForRequirements, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/parser/document-parser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputParseDocumentForRequirements, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentParserApi - functional programming interface
 * @export
 */
export const DocumentParserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentParserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Parse document for family requirements
         * @param {InputParseDocumentForFamilyRequirements} [inputParseDocumentForFamilyRequirements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parseDocumentForFamilyRequirements(inputParseDocumentForFamilyRequirements?: InputParseDocumentForFamilyRequirements, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FamilyServiceDocumentStructureExtended>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parseDocumentForFamilyRequirements(inputParseDocumentForFamilyRequirements, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentParserApi.parseDocumentForFamilyRequirements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Parse document for requirements
         * @param {InputParseDocumentForRequirements} [inputParseDocumentForRequirements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parseDocumentForRequirements(inputParseDocumentForRequirements?: InputParseDocumentForRequirements, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceDocumentStructureExtended>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parseDocumentForRequirements(inputParseDocumentForRequirements, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentParserApi.parseDocumentForRequirements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentParserApi - factory interface
 * @export
 */
export const DocumentParserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentParserApiFp(configuration)
    return {
        /**
         * 
         * @summary Parse document for family requirements
         * @param {InputParseDocumentForFamilyRequirements} [inputParseDocumentForFamilyRequirements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseDocumentForFamilyRequirements(inputParseDocumentForFamilyRequirements?: InputParseDocumentForFamilyRequirements, options?: RawAxiosRequestConfig): AxiosPromise<Array<FamilyServiceDocumentStructureExtended>> {
            return localVarFp.parseDocumentForFamilyRequirements(inputParseDocumentForFamilyRequirements, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Parse document for requirements
         * @param {InputParseDocumentForRequirements} [inputParseDocumentForRequirements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseDocumentForRequirements(inputParseDocumentForRequirements?: InputParseDocumentForRequirements, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceDocumentStructureExtended>> {
            return localVarFp.parseDocumentForRequirements(inputParseDocumentForRequirements, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentParserApi - interface
 * @export
 * @interface DocumentParserApi
 */
export interface DocumentParserApiInterface {
    /**
     * 
     * @summary Parse document for family requirements
     * @param {InputParseDocumentForFamilyRequirements} [inputParseDocumentForFamilyRequirements] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentParserApiInterface
     */
    parseDocumentForFamilyRequirements(inputParseDocumentForFamilyRequirements?: InputParseDocumentForFamilyRequirements, options?: RawAxiosRequestConfig): AxiosPromise<Array<FamilyServiceDocumentStructureExtended>>;

    /**
     * 
     * @summary Parse document for requirements
     * @param {InputParseDocumentForRequirements} [inputParseDocumentForRequirements] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentParserApiInterface
     */
    parseDocumentForRequirements(inputParseDocumentForRequirements?: InputParseDocumentForRequirements, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceDocumentStructureExtended>>;

}

/**
 * DocumentParserApi - object-oriented interface
 * @export
 * @class DocumentParserApi
 * @extends {BaseAPI}
 */
export class DocumentParserApi extends BaseAPI implements DocumentParserApiInterface {
    /**
     * 
     * @summary Parse document for family requirements
     * @param {InputParseDocumentForFamilyRequirements} [inputParseDocumentForFamilyRequirements] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentParserApi
     */
    public parseDocumentForFamilyRequirements(inputParseDocumentForFamilyRequirements?: InputParseDocumentForFamilyRequirements, options?: RawAxiosRequestConfig) {
        return DocumentParserApiFp(this.configuration).parseDocumentForFamilyRequirements(inputParseDocumentForFamilyRequirements, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Parse document for requirements
     * @param {InputParseDocumentForRequirements} [inputParseDocumentForRequirements] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentParserApi
     */
    public parseDocumentForRequirements(inputParseDocumentForRequirements?: InputParseDocumentForRequirements, options?: RawAxiosRequestConfig) {
        return DocumentParserApiFp(this.configuration).parseDocumentForRequirements(inputParseDocumentForRequirements, options).then((request) => request(this.axios, this.basePath));
    }
}

